type UnknownRecord = Record<string, unknown>;

export function cloneTemplateItem<T extends UnknownRecord>(items: unknown[]): T | null {
  if (!Array.isArray(items) || items.length === 0 || !items[0] || typeof items[0] !== 'object') {
    return null;
  }

  return clonePlain(items[0] as T);
}

export function resetLocalizedLabelContent(
  label: unknown,
  locale: string,
  text = '',
): UnknownRecord {
  const next = label && typeof label === 'object'
    ? label as UnknownRecord
    : { kind: 'static', templateParams: { labels: {}, links: {}, countdowns: {} }, appearance: {}, layout: { insets: {} } };

  const templateParams = next.templateParams && typeof next.templateParams === 'object'
    ? next.templateParams as UnknownRecord
    : {};
  next.templateParams = {
    ...templateParams,
    labels: templateParams.labels && typeof templateParams.labels === 'object' ? templateParams.labels : {},
    links: templateParams.links && typeof templateParams.links === 'object' ? templateParams.links : {},
    countdowns: templateParams.countdowns && typeof templateParams.countdowns === 'object' ? templateParams.countdowns : {},
  };
  next.translations = { [locale]: text };
  return next;
}

export function resetAssetTranslations(asset: unknown): UnknownRecord {
  const next = asset && typeof asset === 'object'
    ? asset as UnknownRecord
    : { appearance: {}, layout: { insets: {} } };

  next.translations = {};
  return next;
}

export function clonePlain<T>(value: T): T {
  if (typeof structuredClone === 'function') {
    return structuredClone(value);
  }
  return JSON.parse(JSON.stringify(value)) as T;
}
